// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerBoxWidget":"bfh_a bie_tr","StrollerBoxWidget__imageCounselling":"bfh_b bie_kg"};